// 路由meta的title项 必须为 该多语言对应字段名
import warehouseDataIcon from '@/assets/images/sidebar-icon/warehouse-data-icon.svg'
import warehousingManagementIcon from '@/assets/images/sidebar-icon/warehousing-management-icon.svg'
import abnormalDataIcon from '@/assets/images/sidebar-icon/abnormal-data-icon.svg'
import baseSettingIcon from '@/assets/images/sidebar-icon/base-setting-icon.svg'
import outWarehouseManagementIcon from '@/assets/images/sidebar-icon/out-warehouse-management-icon.svg'
import orderManagementIcon from '@/assets/images/sidebar-icon/order-management-icon.svg'
import palletManagementIcon from '@/assets/images/sidebar-icon/pallet-management-icon.svg'
import deliveryReservationIcon from "@/assets/images/sidebar-icon/delivery-reservation-icon.svg"
import loadingLotIcon from "@/assets/images/sidebar-icon/loading-lot.svg"
import returnGoodsIcon from "@/assets/images/sidebar-icon/return_goods_icon.svg"
import dropShippingOutwarehouseIcon from "@/assets/images/sidebar-icon/drop-shipping-outwarehouse-icon.svg"
import goodChangeLabelIcon from "@/assets/images/sidebar-icon/good-change-label_icon.svg"
import rfidIcon from "@/assets/images/sidebar-icon/rfid-icon.svg"
import overseasQrCodeStatistics from "@/assets/images/sidebar-icon/overseas_qr_code_statistics.svg"


export default [
  {
    path: '/operateCenter',
    name: 'operateCenter',
    component: () => import('@/views/operate-center'),
    children: [
      {
        path: '/operateCenterIndex', // 数据统计
        name: 'warehouseData',
        component: () => import('@/views/operate-center/warehouse-data'),
        redirect: '/operateCenter/warehouseData/index',
        meta: {
          title: 'data_statistics',
          icon: warehouseDataIcon,
          isMulti: true,
        },
        children: [
          {
            path: '/operateCenter/warehouseData/index', // 仓库数据
            name: 'warehouseDataIndex',
            component: () => import('@/views/operate-center/warehouse-data/warehouse-data-index'),
            meta: {
              title: 'warehouse_data',
              isShowing: true,
              activeTitle: 'warehouseDataIndex'
            },
          },
          {
            path: '/operateCenter/warehouseData/subareaData',
            name: 'warehouseSubareaData',
            component: () => import('@/views/operate-center/warehouse-data/warehouse-subarea-data'),
            meta: {
              title: 'classification_data',
              isShowing: false
            },
          },
          {
            path: '/operateCenter/warehouseData/subareaDetail',
            name: 'warehouseSubareaDetail',
            component: () => import('@/views/operate-center/warehouse-data/warehouse-subarea-detail'),
            meta: {
              title: 'classification_details',
              isShowing: false
            },
          },
          {
            path: '/operateCenter/warehouseData/palletDetail',
            name: 'warehousePalletDetail',
            component: () => import('@/views/operate-center/warehouse-data/warehouse-pallet-detail'),
            meta: {
              title: 'pela_details',
              isShowing: false
            },
          },
          {
            path: '/operateCenter/warehouseData/goodsAgeStatistics', // 货物库龄统计
            name: 'goodsAgeStatistics',
            component: () => import('@/views/operate-center/warehouse-data/goods-age-statistics'),
            meta: {
              title: 'goods_age_statistics',
              isShowing: true,
              activeTitle: 'goodsAgeStatistics'
            },
          },

          {
            path: "/operateCenter/warehouseData/overseasQrCodeStatisticsIndex", // 海外扫码统计
            name: "overseasQrCodeStatisticsIndex",
            component: () => import("@/views/operate-center/warehouse-data/overseas-qr-code-statistics-index"),
            meta: {
              title: 'overseas_qr_code_statistics',
              isShowing: true,
            }
          },
        ]
      },
      {
        path: '/operateCenter/warehousingManagement',  // 入库管理
        name: 'warehousingManagement',
        component: () => import('@/views/operate-center/warehousing-management'),
        redirect: '/operateCenter/warehousingManagement/index',
        meta: {
          title: 'cargo_entry_management',
          icon: warehousingManagementIcon,
          isMulti: true,
        },
        children: [
          {
            path: '/operateCenter/warehousingManagement/index',
            name: 'warehousingManagementIndex',
            component: () => import('@/views/operate-center/warehousing-management/warehousing-management-index'),
            meta: {
              title: 'cargo_entry_management',
              isShowing: true,
              activeTitle: 'warehousingManagementIndex'
            }
          },
          {
            path: '/operateCenter/warehousingManagement/detail',
            name: 'warehousingManagementDetail',
            component: () => import('@/views/operate-center/warehousing-management/warehousing-management-detail'),
            meta: {
              title: 'cargo_entry_details',
              isShowing: false,
              activeTitle: 'warehousingManagementIndex'
            }
          },
          {
            path: '/operateCenter/warehousingManagement/waybillDetail',
            name: 'warehousingWaybillDetail',
            component: () => import('@/views/operate-center/warehousing-management/warehousing-management-waybillDetail'),
            meta: {
              title: 'Shipment_details',
              isShowing: false,
            }
          },

          { // 入库汇总
            path: '/operateCenter/warehousingManagement/warehousingSummary',
            name: 'warehousingSummary',
            component: () => import('@/views/operate-center/warehousing-management/warehousing-summary-index'),
            meta: {
              title: 'warehousing_summary',
              isShowing: true
            }
          },
          {
            path: '/operateCenter/warehousingManagement/warehousingSummaryDetail',
            name: 'warehousingSummaryDetail',
            component: () => import('@/views/operate-center/warehousing-management/warehousing-summary-detail'),
            meta: {
              title: 'warehousing_summary_details',
              isShowing: false,
              activeTitle: 'warehousingSummary'
            }
          },
        ]
      },
      {
        path: '/operateCenter/outWarehouseManagement', // 出库管理
        name: 'outWarehouseManagement',
        component: () => import('@/views/operate-center/out-warehouse-management'),
        redirect: '/operateCenter/outWarehouseManagement/outWarehouseManagement',
        meta: {
          title: 'load_output_administration',
          icon: outWarehouseManagementIcon,
          isMulti: true,
        },
        children: [
          {
            path: '/operateCenter/outWarehouseManagement/outWarehouseManagement',
            name: 'outWarehouseManagement',
            component: () => import('@/views/operate-center/out-warehouse-management/out-warehouse-management-index'),
            meta: {
              title: 'Out_warehouse_management',
              isShowing: true
            }
          },
          {
            path: '/operateCenter/outWarehouseManagement/outWarehouseDetail', // 出库详情
            name: 'outWarehouseDetail',
            component: () => import('@/views/operate-center/out-warehouse-management/out-warehouse-detail'),
            meta: {
              title: 'load_output_details',
              isShowing: false,
              activeTitle: 'outWarehouseManagement'
            },
          },
          {
            path: '/operateCenter/outWarehouseManagement/waybillDetail', // 运单详情
            name: 'outWarehouseWaybillDetail',
            component: () => import('@/views/operate-center/out-warehouse-management/out-warehouse-waybill-detail'),
            meta: {
              title: 'Shipment_details',
              isShowing: false
            },
          },
          // 出库单换标
          {
            path: '/operateCenter/outWarehouseManagement/outOfStockOrderChangeLabel',
            name: 'outOfStockOrderChangeLabel',
            component: () => import('@/views/operate-center/out-warehouse-management/change-label-index'),
            meta: {
              title: 'out_of_stock_order_change_label',
              isShowing: true
            }
          },
          {
            path: '/operateCenter/outWarehouseManagement/outOfStockOrderChangeLabelDetail',
            name: 'outOfStockOrderChangeLabelDetail',
            component: () => import('@/views/operate-center/out-warehouse-management/change-label-detail'),
            meta: {
              title: 'out_of_stock_order_change_label_details',
              isShowing: false,
              activeTitle: 'outOfStockOrderChangeLabel'
            },
          },
          {
            path: '/operateCenter/outWarehouseManagement/warehouseLoading',
            name: 'warehouseLoading',
            component: () => import('@/views/operate-center/out-warehouse-management/warehouse-loading-index'),
            meta: {
              title: 'warehouse_loading',
              isShowing: true,
              activeTitle: 'warehouseLoading'
            },
          },
          {
            path: '/operateCenter/outWarehouseManagement/warehouseLoadingDetail',
            name: 'warehouseLoadingDetail',
            component: () => import('@/views/operate-center/out-warehouse-management/warehouse-loading-detail'),
            meta: {
              title: 'Details_of_warehouse_delivery',
              isShowing: false,
              activeTitle: 'warehouseLoadingDetail'
            },
          },

          // 出库单提取标签
          {
            path: '/operateCenter/outWarehouseManagement/outboundOrderExtractionLabel',
            name: 'outboundOrderExtractionLabel',
            component: () => import('@/views/operate-center/out-warehouse-management/extraction-label-index'),
            meta: {
              title: 'outbound_order_extraction_label',
              isShowing: true
            }
          },

          // 亚马逊预约送仓登记
          {
            path: '/operateCenter/outWarehouseManagement/amazonAppointment',
            name: 'amazonAppointment',
            component: () => import('@/views/operate-center/out-warehouse-management/amazon-appointment-index'),
            meta: {
              title: 'Amazon_appointment_delivery_registration',
              isShowing: true
            }
          },
          // 亚马逊送仓货件信息
          {
            path: '/operateCenter/outWarehouseManagement/amazonInformation',
            name: 'amazonInformation',
            component: () => import('@/views/operate-center/out-warehouse-management/amazon-information-index'),
            meta: {
              title: 'Amazon_delivery_shipping_information',
              isShowing: true
            }
          },
          // 标签分割
          {
            path: '/operateCenter/outWarehouseManagement/tagSeparation',
            name: 'tagSeparation',
            component: () => import('@/views/operate-center/out-warehouse-management/tag-separation-index'),
            meta: {
              title: 'Tag_separation',
              isShowing: true
            }
          },
          // ocr识别提取excel
          {
            path: '/operateCenter/outWarehouseManagement/ocrExtractExcel',
            name: 'ocrExtractExcel',
            component: () => import('@/views/operate-center/out-warehouse-management/extract-excel-index'),
            meta: {
              title: 'ocr_extract_excel',
              isShowing: true
            }
          },
          // 保税仓装车
          {
            path: '/operateCenter/outWarehouseManagement/truckLoadingBondedWarehouse',
            name: 'truckLoadingBondedWarehouse',
            component: () => import('@/views/operate-center/out-warehouse-management/truckLoading-bondedWarehouse-index'),
            meta: {
              title: 'truck_loading_bonded_warehouse',
              isShowing: true
            }
          },
          {
            path: '/operateCenter/outWarehouseManagement/truckLoadingBondedWarehouseDetail',
            name: 'truckLoadingBondedWarehouseDetail',
            component: () => import('@/views/operate-center/out-warehouse-management/truckLoading-bondedWarehouse-detail'),
            meta: {
              title: 'truck_loading_bonded_warehouse_details',
              isShowing: false,
              activeTitle: 'truckLoadingBondedWarehouse'
            },
          },
        ]
      },
      // 一件代发出库
      {
        path: '/operateCenter/dropShippingOutwarehouse',
        name: 'dropShippingOutwarehouse',
        component: () => import('@/views/operate-center/drop-shipping-outwarehouse'),
        redirect: '/operateCenter/dropShippingOutwarehouse/index',
        meta: {
          title: 'drop_shipping_outwarehouse',
          icon: dropShippingOutwarehouseIcon,
          isMulti: false,
        },
        children: [
          {
            path: '/operateCenter/dropShippingOutwarehouse/index',
            name: 'dropShippingOutwarehouseIndex',
            component: () => import('@/views/operate-center/drop-shipping-outwarehouse/drop-shipping-outwarehouse-index'),
            meta: {
              title: 'drop_shipping_outwarehouse',
              isShowing: false
            }
          },
          {
            path: '/operateCenter/dropShippingOutwarehouse/detail',
            name: 'dropShippingOutwarehouseDetail',
            component: () => import('@/views/operate-center/drop-shipping-outwarehouse/drop-shipping-outwarehouse-detail'),
            meta: {
              title: 'drop_shipping_outwarehouse_detail',
              isShowing: false
            }
          },
        ]
      },
      // {
      //     path: '/operateCenter/orderManagement',  // 订单管理
      //     name: 'orderManagement',
      //     component: () => import('@/views/operate-center/order-management'),
      //     redirect: '/operateCenter/orderManagement/index',
      //     meta: {
      //         title: 'order_administration',
      //         icon: orderManagementIcon,
      //         isMulti: false,
      //     },
      //     children: [
      //         {
      //             path: '/operateCenter/orderManagement/index',
      //             name: 'orderManagementIndex',
      //             component: () => import('@/views/operate-center/order-management/order-management-index'),
      //             meta: {
      //                 title: 'order_administration',
      //                 isShowing: false
      //             }
      //         },
      //         {
      //             path: '/operateCenter/orderManagement/orderDetail', // 订单详情
      //             name: 'orderDetail',
      //             component: () => import('@/views/operate-center/order-management/order-detail'),
      //             meta: {
      //                 title: 'order_details',
      //                 isShowing: false
      //             },
      //         },
      //     ]
      // },
      {
        path: '/operateCenter/containerManagement', // 容器管理
        name: 'containerManagement',
        component: () => import('@/views/operate-center/container-management'),
        redirect: '/operateCenter/containerManagement/index',
        meta: {
          title: 'container_administration',
          icon: palletManagementIcon,
          isMulti: false,
        },
        children: [
          {
            path: '/operateCenter/containerManagement/index',
            name: 'containerManagementIndex',
            component: () => import('@/views/operate-center/container-management/container-management-index'),
            meta: {
              title: 'container_administration',
              isShowing: false
            }
          },
          {
            path: '/operateCenter/containerManagement/detail',
            name: 'containerManagementDetailx',
            component: () => import('@/views/operate-center/container-management/container-detail'),
            meta: {
              title: 'container_details', // 容器详情
              isShowing: false
            }
          },
        ]
      },
      // 装车批次
      {
        name: "loadingLot",
        path: "/operateCenter/loadingLot",
        component: () => import("@/views/operate-center/loading-lot"),
        redirect: "/operateCenter/loadingLot/loadingLotIndex",
        meta: {
          title: 'loadingLot', // 装车批次
          icon: loadingLotIcon,
          isMulti: false,
          isShowing: true
        },
        children: [
          {
            name: "loadingLotIndex",
            path: "/operateCenter/loadingLot/loadingLotIndex",
            component: () => import("@/views/operate-center/loading-lot/loading-lot-index"),
            meta: {
              title: "loadingLot", // 装车批次
              isShowing: true,
            }
          },
          {
            name: "loadingLotDetail",
            path: "/operateCenter/loadingLot/loadingLotDetail",
            component: () => import("@/views/operate-center/loading-lot/loading-lot-detail"),
            meta: {
              title: "lotDetail", // 批次详情
              isShowing: true,
            }
          },
        ]
      },
      // 退货/美墨
      {
        name: "returnGoods",
        path: "/operateCenter/returnGoods",
        component: () => import("@/views/operate-center/return-goods"),
        redirect: "/operateCenter/returnGoods/returnGoodsIndex",
        meta: {
          title: 'returnGoods',
          icon: returnGoodsIcon,
          isMulti: false,
          isShowing: true
        },
        children: [
          {
            name: "returnGoodsIndex",
            path: "/operateCenter/returnGoods/returnGoodsIndex",
            component: () => import("@/views/operate-center/return-goods/return-goods-index"),
            meta: {
              title: "returnGoods",
              isShowing: false,
            }
          }
        ]
      },
      // 美客多预约
      {
        name: "deliveryReservation",
        path: "/operateCenter/deliveryReservation",
        component: () => import("@/views/operate-center/delivery-reservation"),
        redirect: "/operateCenter/deliveryReservation/deliveryReservationStatus",
        meta: {
          title: 'Mercado_Libre_Reservation', // 美客多预约
          icon: deliveryReservationIcon,
          isMulti: true,
          isShowing: true
        },
        children: [
          {
            name: "deliveryReservationStatus",
            path: "/operateCenter/deliveryReservation/deliveryReservationStatus",
            component: () => import("@/views/operate-center/delivery-reservation/reservation-status"),
            meta: {
              title: "Reservation_status", // 预约情况
              isShowing: true,
            }
          },
          {
            name: "deliveryReservationSearch",
            path: "/operateCenter/deliveryReservation/deliveryReservationSearch",
            component: () => import("@/views/operate-center/delivery-reservation/shipmentNo-search"),
            meta: {
              title: "Check_the_shipment_number", // 货件号查询
              isShowing: true
            }
          }
        ]
      },
      {
        path: '/operateCenter/abnormalData', // 异常数据
        name: 'abnormalData',
        component: () => import('@/views/operate-center/abnormal-data'),
        redirect: '/operateCenter/abnormalData/warehousingAbnormal',
        meta: {
          title: 'Abnormal_data',
          icon: abnormalDataIcon,
          isMulti: true,
        },
        children: [
          {
            path: '/operateCenter/abnormalData/warehousingAbnormal', // 入仓异常
            name: 'warehousingAbnormal',
            component: () => import('@/views/operate-center/abnormal-data/warehousing-abnormal'),
            meta: {
              title: 'abnormal_load_input_situation',
              isShowing: true
            }
          },
          {
            path: '/operateCenter/abnormalData/warehousingAbnormalDetail', // 异常详情
            name: 'warehousingAbnormalDetail',
            component: () => import('@/views/operate-center/abnormal-data/warehousing-abnormal-detail'),
            meta: {
              title: 'abnormal_situation_details',
              isShowing: false,
              activeTitle: 'warehousingAbnormal'
            }
          },
          {
            path: '/operateCenter/abnormalData/outWarehouseAbnormal', // 出仓异常
            name: 'outWarehouseAbnormal',
            component: () => import('@/views/operate-center/abnormal-data/out-warehouse-abnormal'),
            meta: {
              title: 'load_output_abnormal_situation',
              isShowing: true
            }
          },
          {
            path: '/operateCenter/abnormalData/outWarehouseAbnormalDetail', // 异常详情
            name: 'outWarehouseAbnormalDetail',
            component: () => import('@/views/operate-center/abnormal-data/out-warehouse-abnormal-detail'),
            meta: {
              title: 'abnormal_situation_details',
              isShowing: false,
              activeTitle: 'outWarehouseAbnormal'
            }
          },
          {
            path: '/operateCenter/abnormalData/ownerlessCargo', // 无主认领货物
            name: 'ownerlessCargo',
            component: () => import('@/views/operate-center/abnormal-data/ownerless-cargo'),
            meta: {
              title: 'No_owner_claimed_the_goods',
              isShowing: true
            }
          },
          {
            path: '/operateCenter/abnormalData/returnClaim', // 退货认领
            name: 'returnClaim',
            component: () => import('@/views/operate-center/abnormal-data/return-claim'),
            meta: {
              title: 'return_claim',
              isShowing: true
            }
          }
          // {
          //     path: '/operateCenter/abnormalData/operationAbnormal',
          //     name: 'operationAbnormal',
          //     component: () => import('@/views/operate-center/abnormal-data/operation-abnormal'),
          //     meta: {
          //         title: 'Operation_exception',
          //         isShowing: true
          //     }
          // },
          // {
          //     path: '/operateCenter/abnormalData/operationAbnormalDetail', // 待更改：异常详情
          //     name: 'operationAbnormalDetail',
          //     component: () => import('@/views/operate-center/abnormal-data/operation-abnormal-detail'),
          //     meta: {
          //         title: 'View_details',
          //         isShowing: false
          //     }
          // },
        ]
      },
      // 异常更新提示
      {
        name: "abnormalUpdatePrompt",
        path: "/operateCenter/abnormalUpdatePrompt",
        component: () => import("@/views/operate-center/abnormal-update-prompt"),
        redirect: "/operateCenter/abnormalUpdatePrompt/abnormalUpdatePromptIndex",
        meta: {
          title: 'abnormal_update_prompt',
          icon: abnormalDataIcon,
          isMulti: false,
          isShowing: true
        },
        children: [
          {
            name: "abnormalUpdatePromptIndex",
            path: "/operateCenter/abnormalUpdatePrompt/abnormalUpdatePromptIndex",
            component: () => import("@/views/operate-center/abnormal-update-prompt/abnormal-update-prompt-index"),
            meta: {
              title: 'abnormal_update_prompt',
              isShowing: false,
            }
          },
        ]
      },
      // //海外扫码统计
      // {
      //   name: "overseasQrCodeStatistics",
      //   path: "/operateCenter/overseasQrCodeStatistics",
      //   component: () => import("@/views/operate-center/overseas-qr-code-statistics"),
      //   redirect: "/operateCenter/overseasQrCodeStatistics/overseasQrCodeStatisticsIndex",
      //   meta: {
      //     title: 'overseas_qr_code_statistics',
      //     icon: overseasQrCodeStatistics,
      //     isMulti: false,
      //     isShowing: true
      //   },
      //   children: [
      //     {
      //       name: "overseasQrCodeStatisticsIndex",
      //       path: "/operateCenter/overseasQrCodeStatistics/overseasQrCodeStatisticsIndex",
      //       component: () => import("@/views/operate-center/overseas-qr-code-statistics/overseas-qr-code-statistics-index"),
      //       meta: {
      //         title: 'overseas_qr_code_statistics',
      //         isShowing: false,
      //       }
      //     },
      //   ]
      // },
      // RFID
      {
        path: '/operateCenter/rfid',
        name: 'rfid',
        component: () => import('@/views/operate-center/rfid'),
        redirect: '/operateCenter/rfid/searchGoodsTask',
        meta: {
          title: 'rfid',
          icon: rfidIcon,
          isMulti: true,
        },
        children: [
          {
            path: '/operateCenter/rfid/searchGoodsTask', // 找货任务
            name: 'searchGoodsTask',
            component: () => import('@/views/operate-center/rfid/search-goods-task-index'),
            meta: {
              title: 'search_goods_task',
              isShowing: true
            }
          },
          {
            path: '/operateCenter/rfid/searchGoodsTaskDetail', // 找货任务详情
            name: 'searchGoodsTaskDetail',
            component: () => import('@/views/operate-center/rfid/search-goods-task-detail'),
            meta: {
              title: 'search_goods_task_details',
              isShowing: false,
              activeTitle: 'searchGoodsTask'
            },
          },
          {
            path: '/operateCenter/rfid/relatedSubOrder', // 关联子单
            name: 'relatedSubOrder',
            component: () => import('@/views/operate-center/rfid/related-sub-order-index'),
            meta: {
              title: 'related_sub_order',
              isShowing: true
            }
          },

          {
            path: '/operateCenter/rfid/inboundInspectionTask', // 入库检测任务
            name: 'inboundInspectionTask',
            component: () => import('@/views/operate-center/rfid/inbound-inspection-task-index'),
            meta: {
              title: 'inbound_inspection_task',
              isShowing: true
            }
          },
          {
            path: '/operateCenter/rfid/inboundInspectionTaskDetail', // 入库检测任务详情
            name: 'inboundInspectionTaskDetail',
            component: () => import('@/views/operate-center/rfid/inbound-inspection-task-detail'),
            meta: {
              title: 'inbound_inspection_task_details',
              isShowing: false,
              activeTitle: 'inboundInspectionTask'
            },
          },
        ]
      },
      {
        path: '/operateCenter/baseSetting', // 基础设置
        name: 'baseSetting',
        component: () => import('@/views/operate-center/base-setting'),
        redirect: '/operateCenter/baseSetting/vehicleManagement',
        meta: {
          title: 'Basic_setup',
          icon: baseSettingIcon,
          isMulti: true,
        },
        children: [
          {
            path: '/operateCenter/baseSetting/vehicleManagement',
            name: 'vehicleManagement',
            component: () => import('@/views/operate-center/base-setting/vehicle-management'),
            meta: {
              title: 'car_management', // 车辆管理
              isShowing: true
            }
          },
          {
            path: '/operateCenter/baseSetting/warehouseManagement',
            name: 'warehouseManagement',
            component: () => import('@/views/operate-center/base-setting/warehouse-management'),
            meta: {
              title: 'location_management', // 库位管理
              isShowing: true
            }
          },
          {
            path: '/operateCenter/baseSetting/areaManagement',
            name: 'areaManagement',
            component: () => import('@/views/operate-center/base-setting/area-management'),
            meta: {
              title: 'Warehouse_details', // 仓库详情
              isShowing: false,
              activeTitle: 'warehouseManagement'
            }
          },
          {
            path: '/operateCenter/baseSetting/subareaManagement',
            name: 'subareaManagement',
            component: () => import('@/views/operate-center/base-setting/subarea-management'),
            meta: {
              title: 'classification_management', // 分区管理
              isShowing: false,
              activeTitle: 'warehouseManagement'
            }
          },
          {
            path: '/operateCenter/baseSetting/storageDetail',
            name: 'storageDetail',
            component: () => import('@/views/operate-center/base-setting/storage-detail'),
            meta: {
              title: 'storage_management', // 库位管理
              isShowing: false,
              activeTitle: 'warehouseManagement'
            }
          },
        ]
      },
      // 货物换标
      {
        name: "goodChangeLabel",
        path: "/operateCenter/goodChangeLabel",
        component: () => import("@/views/operate-center/good-change-label"),
        redirect: "/operateCenter/goodChangeLabel/goodChangeLabelIndex",
        meta: {
          title: 'good_change_label',
          icon: goodChangeLabelIcon,
          isMulti: false,
          isShowing: true
        },
        children: [
          {
            name: "goodChangeLabelIndex",
            path: "/operateCenter/goodChangeLabel/goodChangeLabelIndex",
            component: () => import("@/views/operate-center/good-change-label/good-change-label-index"),
            meta: {
              title: 'good_change_label',
              isShowing: false,
            }
          },
          {
            name: "goodChangeLabelDetail",
            path: "/operateCenter/goodChangeLabel/detail",
            component: () => import("@/views/operate-center/good-change-label/good-change-label-detail"),
            meta: {
              title: 'good_change_label_detail',
              isShowing: false,
            }
          }
        ]
      },
    ]
  },
]